/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CommunicationType,
  ResolvedNotificationPreferences,
} from '../models/index';
import {
    CommunicationTypeFromJSON,
    CommunicationTypeToJSON,
    ResolvedNotificationPreferencesFromJSON,
    ResolvedNotificationPreferencesToJSON,
} from '../models/index';

export interface GetAvailableCommunicationTypesRequest {
    sessionId?: string;
}

export interface GetEffectivePreferencesRequest {
    sessionId?: string;
}

export interface GetRawPreferencesRequest {
    sessionId?: string;
}

export interface GetTenantOutboundPolicyRequest {
    tenantId: string;
    sessionId?: string;
}

export interface GetTenantPreferencesRequest {
    tenantId: string;
    sessionId?: string;
}

export interface UpdateTenantOutboundPolicyRequest {
    tenantId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UpdateTenantPreferencesRequest {
    tenantId: string;
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

export interface UpdateUserPreferencesRequest {
    requestBody: { [key: string]: any; };
    sessionId?: string;
}

/**
 * NotificationPreferencesApi - interface
 * 
 * @export
 * @interface NotificationPreferencesApiInterface
 */
export interface NotificationPreferencesApiInterface {
    /**
     * Communication types with enabled integration instances for current tenant
     * @summary Get available communication types
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    getAvailableCommunicationTypesRaw(requestParameters: GetAvailableCommunicationTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CommunicationType>>>;

    /**
     * Communication types with enabled integration instances for current tenant
     * Get available communication types
     */
    getAvailableCommunicationTypes(requestParameters: GetAvailableCommunicationTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommunicationType>>;

    /**
     * Registry of communication types (email, sms, push, etc.)
     * @summary Get communication types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    getCommunicationTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CommunicationType>>>;

    /**
     * Registry of communication types (email, sms, push, etc.)
     * Get communication types
     */
    getCommunicationTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommunicationType>>;

    /**
     * Current user\'s resolved notification preferences
     * @summary Get effective preferences
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    getEffectivePreferencesRaw(requestParameters: GetEffectivePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedNotificationPreferences>>;

    /**
     * Current user\'s resolved notification preferences
     * Get effective preferences
     */
    getEffectivePreferences(requestParameters: GetEffectivePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedNotificationPreferences>;

    /**
     * Raw preferences and resolution trace for Account Settings UI
     * @summary Get raw preferences with trace
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    getRawPreferencesRaw(requestParameters: GetRawPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Raw preferences and resolution trace for Account Settings UI
     * Get raw preferences with trace
     */
    getRawPreferences(requestParameters: GetRawPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Tenant whitelist/blacklist for email and SMS (admin only)
     * @summary Get tenant outbound policy
     * @param {string} tenantId 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    getTenantOutboundPolicyRaw(requestParameters: GetTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Tenant whitelist/blacklist for email and SMS (admin only)
     * Get tenant outbound policy
     */
    getTenantOutboundPolicy(requestParameters: GetTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Tenant-wide notification defaults (admin only)
     * @summary Get tenant preferences
     * @param {string} tenantId 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    getTenantPreferencesRaw(requestParameters: GetTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Tenant-wide notification defaults (admin only)
     * Get tenant preferences
     */
    getTenantPreferences(requestParameters: GetTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update tenant whitelist/blacklist for email and SMS (admin only)
     * @summary Update tenant outbound policy
     * @param {string} tenantId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    updateTenantOutboundPolicyRaw(requestParameters: UpdateTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update tenant whitelist/blacklist for email and SMS (admin only)
     * Update tenant outbound policy
     */
    updateTenantOutboundPolicy(requestParameters: UpdateTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Update tenant-wide notification defaults (admin only)
     * @summary Update tenant preferences
     * @param {string} tenantId 
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    updateTenantPreferencesRaw(requestParameters: UpdateTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update tenant-wide notification defaults (admin only)
     * Update tenant preferences
     */
    updateTenantPreferences(requestParameters: UpdateTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Update current user\'s notification preferences
     * @summary Update user preferences
     * @param {{ [key: string]: any; }} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationPreferencesApiInterface
     */
    updateUserPreferencesRaw(requestParameters: UpdateUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Update current user\'s notification preferences
     * Update user preferences
     */
    updateUserPreferences(requestParameters: UpdateUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class NotificationPreferencesApi extends runtime.BaseAPI implements NotificationPreferencesApiInterface {

    /**
     * Communication types with enabled integration instances for current tenant
     * Get available communication types
     */
    async getAvailableCommunicationTypesRaw(requestParameters: GetAvailableCommunicationTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CommunicationType>>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/communication-types/available`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CommunicationTypeFromJSON));
    }

    /**
     * Communication types with enabled integration instances for current tenant
     * Get available communication types
     */
    async getAvailableCommunicationTypes(requestParameters: GetAvailableCommunicationTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommunicationType>> {
        const response = await this.getAvailableCommunicationTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Registry of communication types (email, sms, push, etc.)
     * Get communication types
     */
    async getCommunicationTypesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CommunicationType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/communication-types`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CommunicationTypeFromJSON));
    }

    /**
     * Registry of communication types (email, sms, push, etc.)
     * Get communication types
     */
    async getCommunicationTypes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CommunicationType>> {
        const response = await this.getCommunicationTypesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Current user\'s resolved notification preferences
     * Get effective preferences
     */
    async getEffectivePreferencesRaw(requestParameters: GetEffectivePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResolvedNotificationPreferences>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notification-preferences`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResolvedNotificationPreferencesFromJSON(jsonValue));
    }

    /**
     * Current user\'s resolved notification preferences
     * Get effective preferences
     */
    async getEffectivePreferences(requestParameters: GetEffectivePreferencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResolvedNotificationPreferences> {
        const response = await this.getEffectivePreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Raw preferences and resolution trace for Account Settings UI
     * Get raw preferences with trace
     */
    async getRawPreferencesRaw(requestParameters: GetRawPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/notification-preferences/raw`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Raw preferences and resolution trace for Account Settings UI
     * Get raw preferences with trace
     */
    async getRawPreferences(requestParameters: GetRawPreferencesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getRawPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tenant whitelist/blacklist for email and SMS (admin only)
     * Get tenant outbound policy
     */
    async getTenantOutboundPolicyRaw(requestParameters: GetTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantOutboundPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/outbound-policy`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Tenant whitelist/blacklist for email and SMS (admin only)
     * Get tenant outbound policy
     */
    async getTenantOutboundPolicy(requestParameters: GetTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTenantOutboundPolicyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Tenant-wide notification defaults (admin only)
     * Get tenant preferences
     */
    async getTenantPreferencesRaw(requestParameters: GetTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getTenantPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/tenants/{tenantId}/notification-preferences`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Tenant-wide notification defaults (admin only)
     * Get tenant preferences
     */
    async getTenantPreferences(requestParameters: GetTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getTenantPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update tenant whitelist/blacklist for email and SMS (admin only)
     * Update tenant outbound policy
     */
    async updateTenantOutboundPolicyRaw(requestParameters: UpdateTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateTenantOutboundPolicy().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateTenantOutboundPolicy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/outbound-policy`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update tenant whitelist/blacklist for email and SMS (admin only)
     * Update tenant outbound policy
     */
    async updateTenantOutboundPolicy(requestParameters: UpdateTenantOutboundPolicyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTenantOutboundPolicyRaw(requestParameters, initOverrides);
    }

    /**
     * Update tenant-wide notification defaults (admin only)
     * Update tenant preferences
     */
    async updateTenantPreferencesRaw(requestParameters: UpdateTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateTenantPreferences().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateTenantPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/tenants/{tenantId}/notification-preferences`;
        urlPath = urlPath.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update tenant-wide notification defaults (admin only)
     * Update tenant preferences
     */
    async updateTenantPreferences(requestParameters: UpdateTenantPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateTenantPreferencesRaw(requestParameters, initOverrides);
    }

    /**
     * Update current user\'s notification preferences
     * Update user preferences
     */
    async updateUserPreferencesRaw(requestParameters: UpdateUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling updateUserPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/notification-preferences`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update current user\'s notification preferences
     * Update user preferences
     */
    async updateUserPreferences(requestParameters: UpdateUserPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserPreferencesRaw(requestParameters, initOverrides);
    }

}
